import React, {Component} from 'react';
import {Container} from './styles';
import {IoMdClose} from 'react-icons/io';

export default class ModalSelect extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.produtos
        }
    }

    // componentDidMount() {
    //     var str1 = "00:45",
    //     str2 = "00:30";

    //     if (str1 <= str2)
    //         alert("menor ou igual");
    //     else
    //         alert("Time 2 is later than time 1");
    // }

    render() {
        return (
            <Container>
                <div className="default">
                    <div className="close">
                        <button 
                            onClick={() => this.props.closeModal()}>
                            <IoMdClose color="#fff" className="i-close" />
                        </button>
                    </div>
                    <label>
                        Selecione um produto
                    </label>
                </div>
                { this.state.data.map(item => (
                    <div key={item.id}
                        onClick={() => this.props.selecionar(item.id, item.nome)}
                        className='horario-disponivel'>
                        <label className="disponivel">
                            {item.nome}
                        </label>
                    </div>
                )) }
            </Container>
        )
    }
}